import { DateUtil } from "./date_util";

export class BaseModel {
    public static stringifyExclude: string[] = [
        "stringifyExclude",
        "registry",
        "_id",
        "_added_by_id",
        "_added_by_user_type",
        "_added_timestamp"
    ];

    private _id: number = -1;
    private _added_by_user_type: string = "";
    private _added_by_id: number = 0;
    private _added_timestamp: Date = new Date();

    public constructor() {
    }

    public get id(): number {
        return this._id;
    }

    public set id(value: number) {
        this._id = value;
    }

    public get added_by_user_type(): string {
        return this._added_by_user_type;
    }

    public set added_by_user_type(value: string) {
        this._added_by_user_type = value;
    }

    public get added_by_id(): number {
        return this._added_by_id;
    }

    public set added_by_id(value: number) {
        this._added_by_id = value;
    }

    public get added_timestamp(): Date {
        return this._added_timestamp;
    }

    public set added_timestamp(value: any) {
        this._added_timestamp = DateUtil.getDateFromValue(value);
    }

    // This function, when present, is automatically
    // called by the JSON.stringify function.
    public toJSON(stringifyExclude: string[]) {
        return this.flatten(BaseModel.stringifyExclude.concat(stringifyExclude));
    }

    public flatten(exclude: string[]): Object {

        let outObj = Object.create(null);

        for (let key in this) {
            outObj = this.addProperty(this, outObj, key, exclude);
        }

        return outObj;
    }

    protected addProperty(inObj: any, outObj: any, key: string, exclude: string[] | undefined): Object {
        if ((exclude == undefined)
            || (!exclude.includes(key))) {
            let k: string = key;

            if (k.charAt(0) == "_") {
                k = key.substring(1);
            }

            const value = inObj[k];
            outObj[k] = value ? value : null;
        };

        return outObj;
    }
}
